<template>
  <jade-box
    class="flex-1"
    :title="$t('paid.title')"
    hasPadding
  >
    <template>
      <div class="flex flex-col gap-2">
        <jade-text variant="heading-small">R$ {{ data.value }}</jade-text>
        <div>
          <jade-text>{{ computedText.label }}</jade-text>
          <jade-text>{{ computedText.percentage }}</jade-text>
        </div>
      </div>
    </template>
  </jade-box>
</template>

<script>
import { JadeBox, JadeText } from '@jade'
import TransactionStatusManager from './transaction-status.manager'

export default {
  name: 'TransactionStatusPaid',

  components: {
    JadeBox,
    JadeText
  },

  props: {
    data: Object
  },

  computed: {
    computedText () {
      const label = this.$tc('paid.sales', this.data.quantity)
      return TransactionStatusManager.getFormatedLabelAndPercentage(
        this.data,
        label
      )
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "paid": {
        "title": "Pago",
        "description": "Valor total das transações capturadas ou boletos pagos no período. Inclui também boletos pagos a maior.",
        "sales": "cobrança | cobrança | cobranças"
      }
    },
    "en-US": {
      "paid": {
        "title": "Paid",
        "description": "Total amount of captured transactions or paid boletos in the period. Also includes overpaid boletos.",
        "sales": "charge | charge | charges"
      }
    }
  }
  </i18n>
